import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const StudentServices = {
    getByStudentCodeOrIdentNumber: async (searchString = "") => {
        try {
            const response = await axios.get(`${API_BASE_URL}/Student/GetByStudentCodeOrIdentNumber/${searchString}`, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Không thể tải sinh viên!";
            throw new Error(errorMessage);
        }
    },
    generateExamRegistrationZip: async (students) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/Student/GenerateExamRegistrationZip`, students, {
                headers: {
                    'Content-Type': 'application/json',
                },
                responseType: 'blob',
            });
            return response.data;
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Không thể xuất file!";
            throw new Error(errorMessage);
        }
    },
    studentExamRegis: async (students) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/Student/StudentExamRegis`, students, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            console.log(error);
            const errorMessage = error?.response?.data?.message || "Không thể xuất file!";
            throw new Error(errorMessage);
        }
    },

    uploadImage: async (file) => {
        try {
            const formData = new FormData();
            formData.append("file", file);
            const response = await axios.post(`${API_BASE_URL}/Student/UploadAvatar`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data.fileUrl;
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Lỗi khi tải ảnh lên!";
            throw new Error(errorMessage);
        }
    },

    uploadImageBanking: async (file) => {
        try {
            const formData = new FormData();
            formData.append("file", file);
            const response = await axios.post(`${API_BASE_URL}/RegisForm/UploadBankingImage`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data.fileUrl;
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Lỗi khi tải ảnh lên!";
            throw new Error(errorMessage);
        }
    },
    checkDeferred: async (dateCheck) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/Student/CheckDeferred?dateCheck=${dateCheck}`, {
                headers: {
                    "Content-Type": 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Lỗi khi tải ảnh lên!";
            console.log(error);
            throw new Error(errorMessage);
        }
    },
};

export default StudentServices;
